// hasRole: (role) =>
//   Array.isArray(role)
//     ? role.some((r) => user_data.role_names?.includes(r))
//     : user_data.role_names?.includes(role),
//   hasPermission: (permission) =>
//   Array.isArray(permission)
//     ? permission.some((p) => user_data.permissions?.includes(p))
//     : user_data.permission_names?.includes(permission),

export const userHasRole = (user, role) => {
  if (!user || !user.role_names) return false;

  if (Array.isArray(role)) {
    return role.some((r) => user.role_names.includes(r));
  } else {
    return user.role_names.includes(role);
  }
};

export const userHasPermission = (user, permission) => {
  if (!user || !user.permission_names) {
    return false;
  }

  if (Array.isArray(permission)) {
    return permission.some((p) => user.permission_names.includes(p));
  } else {
    return user.permission_names.includes(permission);
  }
};

export const belongsToCustomer = (user, customerId) => {
  return user.kunde_id === customerId;
};
